<script>
import {mapGetters} from 'vuex';

export default {
    name: "OFontsController",
    data() {
        return {
            fonts: []
        }
    },
    watch: {
        isAppLoaded (val) {
            if(val && this.fontsConfig?.fonts?.length) this.fontsMount();
        }
    },
    computed: {
        ...mapGetters([
            'isAppLoaded',
            'getMapConfigProp'
        ]),
        fontsConfig() {
            return this.getMapConfigProp('fonts');
        }
    },
    methods: {
        fontsMount() {
            // this.fontsConfig.fonts.forEach(font => {
            //     const fontUrl = font.files.reduce((acc, {url, type}) =>`${acc ? acc + ',' : ''} url(${url}) format("${type}")` , '')
            //     this.fonts.push(new FontFace(font.name, fontUrl, font?.style))
            // })
            // this.fonts.forEach(async font => {
            //     try {
            //         await font.load();
            //         document.fonts.add(font);
            //     } catch (error) {
            //         console.error('FONT LOAD ERROR', error);
            //     }
            // })
            this.fontsConfig.fonts.forEach(font => {
                const fontUrl = font.files.reduce((acc, {url, type}) =>`${acc ? acc + ',' : ''} url(${url}) format("${type}")` , '')
                const fontStyle = font.style ? Object.entries(font.style).reduce((acc, [key, value]) =>`${acc} font-${key}: ${value};` , '') : '';
                const newStyle = document.createElement('style');
                newStyle.appendChild(document.createTextNode(`
                    @font-face {
                        font-family: "${font.name}";
                        src: ${fontUrl};
                        ${fontStyle}
                    }
                `));

                document.head.appendChild(newStyle);
            })

            if(this.fontsConfig.fontRoles) {
                Object.entries(this.fontsConfig.fontRoles).forEach(([priority, fontName]) => {
                    const root = document.documentElement;
                    root.style.setProperty(`--${priority}-font-family`, fontName);
                })
            }
        }
    },
    render(){ return null }
}

/**
 * data font example, in json format
 */
const testConfig = {
    "fonts": {
        "fonts": [
            {
                "name": "Veles",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/75511588.json",
                        "file_id": "75511588",
                        "type": "webgl"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/57581716.otf",
                        "file_id": "57581716",
                        "type": "otf"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/98557411.eot",
                        "file_id": "98557411",
                        "type": "eot"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/58255979.woff2",
                        "file_id": "58255979",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/88391236.woff",
                        "file_id": "88391236",
                        "type": "woff"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/81554791.ttf",
                        "file_id": "81554791",
                        "type": "ttf"
                    }
                ],
                "style": {
                    "style": "normal",
                    "weight": "400"
                },
                "auto_load": true
            },
            {
                "name": "Miratrix",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/14118997/61315428/75446572.otf",
                        "file_id": "75511588",
                        "type": "otf"
                    }
                ],
                "auto_load": true
            }
        ],
        "fontRoles": {
            "primary": "Veles",
            "secondary": "Miratrix"
        }
    }
}

const realCofig = {
    "fonts": {
        "fonts": [
            {
                "name": "Arial Regular",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/54624135/43681251/73248790.woff2",
                        "file_id": "73248790",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/54624135/43681251/98364749.woff",
                        "file_id": "98364749",
                        "type": "woff"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/54624135/43681251/68669924.ttf",
                        "file_id": "68669924",
                        "type": "ttf"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/54624135/43681251/84844372.eot",
                        "file_id": "84844372",
                        "type": "eot"
                    }
                ],
                "style": {
                    "style": "normal",
                    "weight": "normal"
                },
                "auto_load": true
            },
            // http://fs.mvgcloud.com/assets/59367794/93368713.woff
            {
                "name": "Avenir Next Bold", 
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/69564848/42994183/56497397.woff2",
                        "file_id": "56497397",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/69564848/42994183/23692198.woff",
                        "file_id": "23692198",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://fs.mvgcloud.com/assets/73291648/89892987/44195485.woff              +
            {
                "name": "Montserrat Regular",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/29425945/91331779/99961420.woff2",
                        "file_id": "99961420",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/29425945/91331779/95755658.woff",
                        "file_id": "95755658",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            //http://fs.mvgcloud.com/assets/73291648/89892987/12581229.woff
            {
                "name": "Montserrat Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/29425945/92198740/64367590.woff2",
                        "file_id": "64367590",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/29425945/92198740/46718950.woff",
                        "file_id": "46718950",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Montserrat ExtraBold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/29425945/39125578/21849817.woff2",
                        "file_id": "21849817",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/29425945/39125578/68252656.ttf",
                        "file_id": "68252656",
                        "type": "ttf"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Montserrat Medium",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/29425945/22883269/12629253.woff2",
                        "file_id": "12629253",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/29425945/22883269/43523193.ttf",
                        "file_id": "43523193",
                        "type": "ttf"
                    }
                ],
                "auto_load": true
            },
            // Sohne-Dreiviertelfett.0575ac6d.woff2 +
            {
                "name": "Sohne",
                "style": {
                    "style": "normal",
                    "weight": 600
                },
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/45588776/63719446.woff2",
                        "file_id": "63719446",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/45588776/16229389.otf",
                        "file_id": "16229389",
                        "type": "otf"
                    }
                ],
                "auto_load": true
            },
            // https://atrium-app.mvgcloud.com/fonts/S%C3%B6hne-Buch.d57eaf19.woff2
            {
                "name": "Sohne",
                "style": {
                    "style": "normal",
                    "weight": 400
                },
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/93798734/14682469.woff2",
                        "file_id": "14682469",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/93798734/77726362.woff",
                        "file_id": "77726362",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://fs.mvgcloud.com/assets/59367794/93644185.woff
            {
                "name": "Sohne Semi Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/21413847/52754539.woff",
                        "file_id": "52754539",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://fs.mvgcloud.com/assets/59367794/43745548.woff 
            {
                "name": "Sohne Normal",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/93798734/77726362.woff",
                        "file_id": "77726362",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://fs.mvgcloud.com/assets/59367794/25725946.woff
            {
                "name": "Sohne Extra Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/48649946/93936181.woff",
                        "file_id": "93936181",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://fs.mvgcloud.com/assets/59367794/95258722.woff                       +
            {
                "name": "Sohne Medium",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/62775788/15251510.woff",
                        "file_id": "15251510",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://fs.mvgcloud.com/assets/59367794/39874234.woff
            {
                "name": "Sohne Light",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/58239878/55594543.woff",
                        "file_id": "55594543",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://fs.mvgcloud.com/assets/59367794/88769291.woff
            {
                "name": "Sohne Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/49322415/65969311.woff",
                        "file_id": "65969311",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Veles",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/75511588.json",
                        "file_id": "75511588",
                        "type": "webgl"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/57581716.otf",
                        "file_id": "57581716",
                        "type": "otf"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/98557411.eot",
                        "file_id": "98557411",
                        "type": "eot"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/58255979.woff2",
                        "file_id": "58255979",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/88391236.woff",
                        "file_id": "88391236",
                        "type": "woff"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/81554791.ttf",
                        "file_id": "81554791",
                        "type": "ttf"
                    }
                ],
                "style": {
                    "style": "normal",
                    "weight": "400"
                },
                "auto_load": true
            },
            {
                "name": "Miratrix",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/14118997/61315428/75446572.otf",
                        "file_id": "75511588",
                        "type": "otf"
                    }
                ],
                "auto_load": true
            },
            // https://dwf66ci4afxrp.cloudfront.net/maps/79694573/96489374.woff            -
            {
                "name": "DIN Pro",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/11126711/33765961/83317657.woff",
                        "file_id": "83317657",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://dwf66ci4afxrp.cloudfront.net/maps/79694573/18626773.woff
            {
                "name": "DIN Pro Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/11126711/55222419/49595864.woff",
                        "file_id": "49595864",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://dwf66ci4afxrp.cloudfront.net/maps/79694573/56771293.woff            -
            {
                "name": "Pantone Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/18549229/32899469/58784873.woff",
                        "file_id": "58784873",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://dwf66ci4afxrp.cloudfront.net/maps/79694573/76422324.woff            
            {
                "name": "Pantone Regular",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/18549229/68483498/75751825.woff",
                        "file_id": "75751825",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://fs.mvgcloud.com/assets/59367794/87767816.woff                       
            {
                "name": "Avenir Next Regular",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/69564848/16423572/52655647.woff",
                        "file_id": "52655647",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://dwf66ci4afxrp.cloudfront.net/maps/79694573/58676116.woff            
            {
                "name": "Panton Extra Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/18549229/33359458/76575758.woff",
                        "file_id": "76575758",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // https://app.mvgcloud.com/fonts/ArialBold.2344252f.woff2                     
            {
                "name": "Arial Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/54624135/75731980/32936863.woff2",
                        "file_id": "32936863",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/54624135/75731980/32951127.woff",
                        "file_id": "32951127",
                        "type": "woff"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/54624135/75731980/52323375.ttf",
                        "file_id": "52323375",
                        "type": "ttf"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/54624135/75731980/61718935.eot",
                        "file_id": "61718935",
                        "type": "eot"
                    }
                ],
                "auto_load": true
            },
            // https://fs.mvgcloud.com/assets/59367794/46857190/57158194.woff2
            {
                "name": "Heldane Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/46857190/57158194.woff2",
                        "file_id": "57158194",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/46857190/67197523.otf",
                        "file_id": "67197523",
                        "type": "otf"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/46857190/59641258.json",
                        "file_id": "59641258",
                        "type": "json"
                    }
                ],
                "auto_load": true
            },
            //Source Sans Pro
            {
                "name": "Source Sans Pro",
                "style": {
                    "style": "normal",
                    "weight": 600
                },
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/66518266/55345198.woff2",
                        "file_id": "55345198",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/66518266/52169313.ttf",
                        "file_id": "52169313",
                        "type": "ttf"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/66518266/58658198.otf",
                        "file_id": "58658198",
                        "type": "otf"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Source Sans Pro",
                "style": {
                    "style": "normal",
                    "weight": 700
                },
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/66518266/19982687.woff2",
                        "file_id": "19982687",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/66518266/19682266.ttf",
                        "file_id": "19682266",
                        "type": "ttf"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/66518266/51669670.otf",
                        "file_id": "51669670",
                        "type": "otf"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Source Sans Pro",
                "style": {
                    "style": "normal",
                    "weight": 400
                },
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/66518266/31485360.woff2",
                        "file_id": "31485360",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/66518266/98248810.ttf",
                        "file_id": "98248810",
                        "type": "ttf"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/66518266/52331943.otf",
                        "file_id": "52331943",
                        "type": "otf"
                    }
                ],
                "auto_load": true
            },
        ]
    }
}

</script>
